import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../../common/components/functional/customButton/CustomButton";
import {
  canExpertApproveEntries,
  canExpertEditEntries,
} from "../../../user/accessRightChecks";

interface Props {
  handleSave: (markSelectedAsApproved: boolean) => void;
  hideApprove?: boolean;
  disableApprove?: boolean;
  saveDisabled?: boolean;
}

const SaveAndApproveButtons = ({
  handleSave,
  hideApprove,
  disableApprove,
  saveDisabled,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        cursor: "grab",
      }}
    >
      <CustomButton
        accessRightChecks={[canExpertEditEntries]}
        onClick={() => handleSave(false)}
        variant={"outlined"}
        disabled={saveDisabled}
        sx={{
          minHeight: "42px",
          borderRadius: "20px",
          minWidth: "120px",
          marginTop: "35px",
        }}
      >
        {t("common:save")}
      </CustomButton>
      {!hideApprove && (
        <CustomButton
          accessRightChecks={[canExpertApproveEntries]}
          disabled={disableApprove}
          onClick={() => handleSave(true)}
          variant={"contained"}
          sx={{
            minHeight: "42px",
            borderRadius: "20px",
            minWidth: "120px",
            marginTop: "35px",
            marginLeft: "10px",
          }}
        >
          {t("hourEntries:saveAndApprove")}
        </CustomButton>
      )}
    </Box>
  );
};

export default SaveAndApproveButtons;
